import { Step } from "../Steps/Step/Step";
import { StepState } from "./StepState";


// TODO: ta klasa jest chyba bez sensu
export class MarkedStep
{
    public State = StepState.Unknown;
    public IsCurrent = false;

    public get IsBeforeCurrent(): boolean
    {
        return !this.IsUnDone && !this.IsCurrent;
    }

    public get IsAfterCurrent(): boolean
    {
        return this.IsUnDone && !this.IsCurrent;
    }

    public get IsDone(): boolean
    {
        return this.Step.IsWellDone || this.Step.IsFailedDone;
    }
    
    public get IsUnDone(): boolean
    {
        return !this.Step.IsWellDone && !this.Step.IsFailedDone;
    }

    constructor(public Step: Step<any>)
    {
        if (Step.IsInInitialState)
            this.State = StepState.Initial;
        else if (Step.IsInProgress)
            this.State = StepState.InProgress;
        else if (Step.IsWellDone)
            this.State = StepState.WellDone;
        else if (Step.IsFailedDone)
            this.State = StepState.Failed;
        else
            this.State = StepState.Unknown;
    }

    public get StateAsIcon(): string
    {
        switch (this.State)
        {
            case StepState.Failed: return "❌";
            case StepState.WellDone: return "✅";
            case StepState.InProgress: return "✔️"; // ☑️ 
            case StepState.Initial: return "🕜";
            default: return "❓";
        }
    }
}
